import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { PublicCryptoWillGuard } from './guards/public-crypto-will.guard';
import { SelectivePreloadingStrategy } from './routing/selective-preloading.strategy';

const routes: Routes = [
  // Public route for Business user password reset links
  {
    path: 'business/resetPassword/:verifyToken',
    loadChildren: () =>
      import('./modules/authentication/business-reset-password/business-reset-password.module').then(
        (module) => module.BusinessResetPasswordModule
      ),
  },
  // Public route for Business user registration verification links
  {
    path: 'business/verify-register/:verifyToken',
    loadChildren: () =>
      import('./modules/authentication/business-verify-register/business-verify-register.module').then(
        (module) => module.BusinessVerifyRegisterModule
      ),
  },
  // Same flow as verify-register — backend / emails often use `verifyAssociate` in the URL
  {
    path: 'business/verifyAssociate/:verifyToken',
    loadChildren: () =>
      import('./modules/authentication/business-verify-register/business-verify-register.module').then(
        (module) => module.BusinessVerifyRegisterModule
      ),
  },
  // Public advisor self-registration (company picker + profile fields)
  {
    path: 'advisor-registration',
    loadChildren: () =>
      import(
        './modules/authentication/public-associate-register/public-associate-register.module'
      ).then((module) => module.PublicAssociateRegisterModule),
  },
  {
    path: 'business/advisor-registration',
    loadChildren: () =>
      import(
        './modules/authentication/public-associate-register/public-associate-register.module'
      ).then((module) => module.PublicAssociateRegisterModule),
  },
  {
    path: '',
    canMatch: [PublicCryptoWillGuard],
    loadChildren: () =>
      import(`./modules/authentication/authentication.module`).then(
        (module) => module.AuthenticationModule
      ),
  },
  // Public Legacy Score entry (choose easy / personalized) — no auth, no shell
  {
    path: 'legacy-score',
    pathMatch: 'full',
    loadChildren: () =>
      import('./modules/public-pages/legacy-score-choose/legacy-score-choose.module').then(
        (module) => module.LegacyScoreChooseModule
      ),
  },
  // /legacy-score/report — Stripe checkout return (legacy-score.report.service returnUrl).
  {
    path: 'legacy-score',
    loadChildren: () =>
      import('./modules/public-pages/public-legacy-score/public-legacy-score.module').then(
        (module) => module.PublicLegacyScoreModule
      ),
  },
  {
    path: 'legacy-score-easy',
    loadChildren: () =>
      import('./modules/public-pages/legacy-score-easy-flow/legacy-score-easy-flow.module').then(
        (module) => module.LegacyScoreEasyFlowModule
      ),
  },
  {
    path: 'legacy-score-personalized',
    loadChildren: () =>
      import('./modules/public-pages/legacy-score-personalized/legacy-score-personalized.module').then(
        (module) => module.LegacyScorePersonalizedModule
      ),
  },
  // Old URL, kept for existing links and bookmarks.
  { path: 'legacy-score-choose', redirectTo: 'legacy-score', pathMatch: 'full' },
  {
    path: '',
    loadChildren: () =>
      import(`./modules/root/root.module`).then(
        (module) => module.RootModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'will-preview/:id',
    loadChildren: () =>
      import(`./modules/root/will-preview/will-preview.module`).then(
        (module) => module.WillPreviewModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'rewards',
    loadChildren: () =>
      import(`./modules/root/rewards/rewards.module`).then(
        (module) => module.RewardsModule
      ),
  },
  {
    path: 'legacybot',
    loadChildren: () =>
      import(`./modules/public-pages/public-pages.module`).then(
        (module) => module.PublicPagesModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: SelectivePreloadingStrategy,
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
